export default window.ReactDOM;
export const createRoot = window.ReactDOM.createRoot;
